"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.switchStyles = void 0;

var _getColor = require("../styleHelpers/getColor");

var _getSpacing = require("../styleHelpers/getSpacing");

var _checkableBaseStyles = require("../shared/checkableBaseStyles");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var switchStyles = _objectSpread(_objectSpread({}, _checkableBaseStyles.checkableBaseStyles), {}, {
  innerPadding: {
    small: (0, _getSpacing.getSpacing)(1),
    medium: (0, _getSpacing.getSpacing)(1)
  },
  handleSize: {
    medium: '18px',
    small: '12px'
  },
  handleColorChecked: (0, _getColor.getColor)('brand'),
  handleColorUnchecked: (0, _getColor.getColor)('gray', '500'),
  boxTransition: [['box-shadow', '0.3s', 'ease-in-out']],
  handleTransition: [['background-color', '0.15s', 'ease-in-out'], ['transform', '0.15s', 'ease-in-out']]
});

exports.switchStyles = switchStyles;